import { useLang } from "../context/LanguageContext";
import en from "../locales/en";
import de from "../locales/de";
import ar from "../locales/ar";

const translations = {
  en, de, ar
};

export const useTranslate = () => {
  const { lang } = useLang();

  return (key) => translations[lang]?.[key] || translations["en"]?.[key] || key;
};